module.exports = __webpack_public_path__ + "static/media/location.ed9f2bdd.svg";